export { default as ReviewSlider } from './review-slider';
